import Link from "next/link"
import SkeletonLoader from "@/Layout/SkeletonLoader"

const AuthBottom = (props) => {
    const { title, link, linkText, skeletonLoading, onLinkClick } = props
    return (
        <p className='text-center mt-5 sm:pb-8 pb-5 flex items-center justify-center text-sm'>
            {skeletonLoading ? <SkeletonLoader width="300" height={24} rows={1} /> : <>
                {title} &nbsp;
                <Link href={link} className='text-sm font-semibold' onClick={onLinkClick}>{linkText}</Link></>
            }
        </p >
    )
}

export default AuthBottom
